"use client";

import { useEffect } from "react";

import { ErrorFallback } from "@/shared/ui/error-fallback";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    console.error("[app/global-error]", error);
  }, [error]);

  return (
    <html lang="ru">
      <body>
        <ErrorFallback
          fullPage
          title="Критическая ошибка"
          message="Приложение не удалось загрузить. Попробуйте обновить страницу."
          reset={reset}
        />
      </body>
    </html>
  );
}
